import React from "react";
import { NavLink } from "react-router-dom";

export default function SocialMediaContentCreation() {
  return (
    <section className="container page-top pt-10" style={{ paddingTop: "6rem" }}>
      <div className="container">
        {/* Title Section */}
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h1 className="display-5 fw-bold text-primary">Social Media Multimedia Content Creation</h1>
            <h5 className="text-muted">
              Elevate Your Brand with Stunning Visuals, Videos & Strategy
            </h5>
            <hr className="w-25 mx-auto" />
          </div>
        </div>

        {/* Image and Introduction */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6">
            <img
              src="https://img.freepik.com/free-vector/social-media-concept-illustration_114360-4311.jpg"
              alt="Social Media Content"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6">
            <h2 className="fw-semibold">Visual Stories That Captivate & Convert</h2>
            <p>
              <strong>Bytlas Intelligence</strong> crafts impactful multimedia content tailored 
              for platforms like Instagram, LinkedIn, Facebook, YouTube, and more. 
              We bring your brand voice to life with scroll-stopping visuals, animations, 
              reels, and branded videos.
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ Motion Graphics & Explainer Videos</li>
              <li className="list-group-item">✅ AI-Generated Voiceovers & Subtitles</li>
              <li className="list-group-item">✅ Reels, Shorts & Video Editing Services</li>
              <li className="list-group-item">✅ Logo Animations & Branded Intros</li>
            </ul>
          </div>
        </div>

        {/* Features Section */}
        <div className="row my-5">
          <div className="col-md-6">
            <h3 className="text-secondary">Content for Every Platform</h3>
            <p>
              Whether it’s a Facebook carousel, a trending reel, or a professional 
              LinkedIn banner — we design and produce high-quality content optimized 
              for every social media platform.
            </p>
            <ul>
              <li>📱 Instagram Reels & Stories</li>
              <li>📽️ YouTube Thumbnails & Video Edits</li>
              <li>🧩 Facebook & LinkedIn Banners</li>
              <li>📊 Infographics, GIFs & Post Templates</li>
            </ul>
          </div>

          <div className="col-md-6">
            <h3 className="text-secondary">Strategic Creativity</h3>
            <p>
              We don’t just create content—we create conversations. 
              With a mix of creativity, market insights, and data-backed strategy, 
              your social media presence becomes a business driver.
            </p>
            <ul>
              <li>🎯 Audience-Specific Messaging</li>
              <li>📈 Data-Driven Content Planning</li>
              <li>📝 Scriptwriting & Concept Development</li>
              <li>🎨 Custom Branding & Theme Design</li>
            </ul>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-4">
          <NavLink to="/contact" className="btn btn-danger px-4 py-2 rounded-pill fw-bold">
            Let's Create Engaging Content Together
          </NavLink>
        </div>
      </div>
    </section>
  );
}
